export const generateProductCardHref = (productHref: string): string => {
  if (typeof window === "undefined") {
    return productHref;
  }
  const sitePath = window.location.pathname;
  return sitePath.includes("/us") && !productHref.startsWith("/us/")
    ? `/us${productHref}`
    : productHref;
};
